export interface User {
  key: number;
  name: string;
  dataIndex: string;
  align: string;
}

export interface listItemType {
  price_type: number;
  status: number;
  order_id: number;
}

export enum priceType {
  '购买' = 1,
  '续费'
}

export enum orderType {
  '免费' = 0,
  '付费',
  '赠送'
}

export enum statusType {
  '未支付' = 0,
  '已支付',
  '已完成'
}
